import { Card } from "antd";
import Meta from "antd/es/card/Meta";
import { useEffect, useState } from "react";

import "./Accounts.css"

import LoadingSpinner from "../LoadingSpinner";
import ApiService from "../../Api.service";
import ApiUrls, { displayError, getAdminPortalBaseUrl } from "../../ApiUrls";
import { openNotification } from "../MainLayout/Notification";
import { useSelector } from "react-redux";

function Accounts() {
    const [accounts, setAccounts] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const email = useSelector((state: any) => state?.auth?.user?.profile?.["email"]);

    useEffect(() => {
        setLoading(true);
        ApiService.get(ApiUrls.getAllAccounts)
            .then(data => {
                if (displayError(data)) {
                    data = data.sort((a, b) => b.is_primary_account - a.is_primary_account);
                    setAccounts(data)
                }
            })
            .catch(e => {
                openNotification("error", "Unable to load the data")
            })
            .finally(() => setLoading(false))
    }, [])

    return <>
        <div className="content-header">
            My Accounts
        </div>
        {
            loading ? <LoadingSpinner /> :
                accounts?.length === 0 ?
                    <div className="content-display-container rounded-grey-border">
                        <div className="message-header">
                            You do not have any accounts.
                        </div>
                    </div> :
                    <div
                        style={{ display: "flex", gridGap: "20px", paddingBottom: "25px", flexWrap: "wrap" }}
                    >
                        {
                            accounts?.map((account) => {
                                return <div key={account?.uid}
                                >
                                    <Card onClick={() => window.open(`${getAdminPortalBaseUrl()}/?email=${email}&uid=${account?.uid}`, '_blank', 'noreferrer')}
                                        style={{
                                            borderColor: account?.is_primary_account ? '#1890ff' : 'white',
                                        }} className="my-account"
                                    >
                                        {account?.is_primary_account && <div style={{ float: "right", marginTop: "-20px", marginRight: "-10px", color: "#1890ff" }}>Primary</div>}
                                        <Meta
                                            style={{ marginTop: "30px", textAlign: "center", cursor: "pointer" }}
                                            title={<div>{account?.name}</div>}
                                            description={<><div style={{ fontWeight: 700 }}>{account?.idp_type}</div>{account?.issuer_url}</>}
                                        />
                                    </Card>
                                </div>
                            })
                        }
                    </div>
        }
    </>
}

export default Accounts;
